import { Form, FormInstance, Select } from "antd";
import { AmountType } from './../../type'
import FixedAmount from "../FixedAmount";
import RandomAmount from "../RandomAmount";
import RandomPercentage from "../RandomPercentage";
import './index.less'
import CustormAmount from "../CustormAmount";
import { useState } from "react";
import RemainAmount from "../RemainAmount";
import AllAmount from "../AllAmount";
import { useTranslation } from "react-i18next";


export default function TransAmountSetting(props: { form: FormInstance, symbol: string | undefined }) {
  const { form, symbol } = props
  // const [type, setType] = useState(AmountType.FixedAmount)
  const type = Form.useWatch("type", form);
  const { t } = useTranslation()
  const options = [
    { value: AmountType.FixedAmount, label: t("manyToMany.fixedAmount") },
    { value: AmountType.AllBalance, label: t("manyToMany.allBalance") },
    { value: AmountType.KeepFixedAmount, label: t("manyToMany.reserveFixedAmount") },
    { value: AmountType.RandomRange, label: t("manyToMany.randomRange") },
    { value: AmountType.Custom, label: t("manyToMany.custom") },
  ];
  return (<div className="trans-amount-setting">
    <div className="trans-amount-setting-head">
      <h4>{t("manyToMany.transferAmount")}</h4>
      <Form.Item
        name="type"
        label={null}
        noStyle
      >
        <Select
          style={{ minWidth: 150 }}
          // onChange={handleChange}
          className="custom-select"
          options={options}
        />
      </Form.Item>
    </div>
    <div className="trans-amount-setting-box">
      {
        type === AmountType.FixedAmount && <FixedAmount form={form} symbol={symbol} />
      }

      {
        type === AmountType.RandomRange && <RandomAmount form={form} symbol={symbol} />
      }

      {
        type === AmountType.KeepFixedAmount && <RemainAmount form={form} symbol={symbol} />
      }

      {
        type === AmountType.AllBalance && <AllAmount form={form} symbol={symbol} />
      }

      {
        type === AmountType.Custom && <CustormAmount form={form} symbol={symbol} />
      }
    </div>
  </div>)
}